import { Box, Tooltip } from "@mui/joy";
import { ApiUserInline } from "griptonite-api-client";
import { useRef } from "react";

import Avatar from "../Avatar";

export const SetterName = ({ setter }: { setter: ApiUserInline }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        textOverflow: "ellipsis",
        overflow: "hidden",
      }}
    >
      <Box sx={{ marginRight: 0.5 }}>
        <Avatar user={setter} size={24} round />
      </Box>
      {setter.firstName} {setter.lastName}
    </Box>
  );
};

export const SettersCell = ({ setters }: { setters: ApiUserInline[] }) => {
  const namesRef = useRef<HTMLDivElement>(null);
  const tooltipEnabled =
    namesRef.current && namesRef.current?.scrollWidth > namesRef.current?.clientWidth;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        flexWrap: "wrap",
        overflow: "hidden",
      }}
    >
      {setters.length ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            div: {
              marginLeft: -2,
              "&:first-of-type": {
                marginLeft: 0,
              },
            },
          }}
        >
          {setters.slice(0, 3).map((setter) => (
            <Avatar key={setter.uuid} user={setter} size={24} round />
          ))}
        </Box>
      ) : (
        "–"
      )}
      <Tooltip
        title={setters.map((setter) => setter.firstName + " " + setter.lastName).join(", ")}
        disableHoverListener={!tooltipEnabled}
        disableFocusListener={!tooltipEnabled}
        disableTouchListener={!tooltipEnabled}
      >
        <Box
          sx={{
            flex: 1,
            overflow: "hidden",
            minWidth: 0,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          ref={namesRef}
        >
          {setters.length === 1
            ? `${setters[0].firstName} ${setters[0].lastName}`
            : setters.map((setter, i) => (
                <span key={setter.uuid}>
                  {setter.firstName} {setter.lastName[0]}.{i !== setters.length - 1 ? ", " : ""}
                </span>
              ))}
        </Box>
      </Tooltip>
    </Box>
  );
};
